import styled from 'styled-components';
import {
    textColor,
    THEME_GREY,
    THEME_RED,
    THEME_SECONDARY,
    THEME_SILVER,
    themeColor
} from '../../../styles/basics/colors';

interface StInputProps {
    error?: boolean;
    bold?: string;
    isDisabled?: boolean;
}
export const StInput = styled.input<StInputProps>`
    font-style: ${props => (!props.value ? 'italic' : 'normal')};
    border-bottom: 1px solid ${props => (props.error ? themeColor(THEME_RED) : themeColor(THEME_SECONDARY))};
    background-color: ${props => (props.error ? 'rgba(208, 2, 27, 0.1)' : null)};
    box-shadow: none !important;
    padding: unset !important;
    font-weight: ${props => (props.bold ? 'bold' : null)};
    opacity: ${props => (props.isDisabled ? '0.5' : '1')};

    ::placeholder {
        ${textColor(THEME_SILVER)};
    }
    :focus::placeholder {
        color: transparent;
    }
`;

export const StSalesDateLabel = styled.p`
    color: ${themeColor(THEME_GREY)};
    font-size: 11px;
    margin-top: 10px;
    line-height: 16px;
`;

export const StSalesDate = styled.strong`
    color: inherit;
`;

export const StSettingsContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 30px;
    justify-content: space-between;
`;

export const StLabelWrapper = styled.div`
    font-size: 15px;
    width: 40%;
`;
